<template>
<div>
    <div class="dashboard__title mt-lg-0 d-lg-flex align-items-lg-center" >
      <h1 class="title--1 mr-lg-3 mb-lg-0">This week's schedule</h1>
      <p class="overview__text" v-if="parent && parent.format_start_date">
        This is the schedule for the pay period starting {{parent.format_start_date}}.
        <a  class="bold-text" style="color: #039be5; text-decoration: underline;" :href="'/days-off-schedules?schedule_id='+parent.id">View live schedule</a>.
        
      </p>
      <p class="overview__text" v-else>
        No live schedules found.

      </p>
      <div class="d-flex align-items-lg-center ml-2" style="width: 50%; font-size: 15px;">Filter by shift:
        <select
          class="form-control custom-select ml-3"
          style="width: 10%;"
          v-model="filtered_shift"
        >
            <option value='1' v-html="'Day'"/>
            <option value='2' v-html="'Evening'"/>
            <option value='3' v-html="'Night'"/>
            <option value='4' v-html="'All shift'"/>
            <!-- <option v-for="(value, i) in array_options[key.model_name]" :key="i" :value="value.decrypted_id" v-html="value.name"/> -->
          </select>
        </div>
    </div>

    <article class="dashboard__schedule" v-if="prior_start_date && prior_start_date != undefined">
      <ScheduleTable
        :prior_start_date="prior_start_date"
        :new_start_date="new_start_date"
        :parent="parent"
        :schedules="schedules"
        used_in="home"
        ref="scheduleTable"
        :view_by_associate="true"
      />
    </article> 
</div>
</template>

<script>
import ScheduleTable from '@/components/DayOffComponent/Schedule/ScheduleTable'
export default {

    components:{
        ScheduleTable
    },

    props:[
        'user'
    ],

    data()
    {
        return{
            rest_api_schedule : 'schedules',
            parent: {},
            schedules: [],
            new_start_date: '',
            prior_start_date: null,
            filtered_shift: '4',

        }
    },

    watch:{
        filtered_shift()
        {
            this.grapic_schedule_table()
        }

    },

    methods:{

        async grapic_schedule_table()
        {
            this.loader(true)

            const http_request = {
                associate_id: this.user.associate_id,
                home: true,
                filtered_shift: this.filtered_shift,
            }

            const response = await this.post(`${this.rest_api_schedule}/search_schedule`, http_request);

            this.loader()

            if(response.status)
            {               
                this.parent = response.data.data.rotation_setup !== undefined ? response.data.data.rotation_setup : null
                this.new_start_date = response.data.new_start_date != undefined ? response.data.new_start_date : ''
                this.prior_start_date = response.data.prior_start_date

                setTimeout(() => {
                    this.schedules = response.data.data.schedules !== undefined ? response.data.data.schedules : []
                }, 500);
                
            }
            else
            {
                this.error_handling(response)
            }

        },
    },

    async mounted()
    {
        await this.grapic_schedule_table()
    }

}
</script>